/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import TemplateHelper from 'utilities/TemplateHelper';
import React, { Component } from 'react';
import FrontendURLs from '../../utilities/FrontendURLs';
import URLs from '../../utilities/URLs';
import { getInfoWindow } from './CustomInfoWindow';
import { getInner } from './swInfoWindow';
import { IStore } from 'redux/storeType';
import { staticBucketReachable } from 'redux/selectors';
import { connect } from 'react-redux';
import MachineHandling from 'utilities/MachineHandling';
import { IMachine } from '@umati/dashboard-types';

interface IMachineInfoWindowProps extends IMachine {
  onMouseLeave?: () => void;
  children?: React.ReactNode;
  isCluster?: boolean;
  staticBucketReachable: boolean;
}

interface IMachineInfoWindowState {
  imageLink: string;
  imageLinkFallback: string;
}

class MachineInfoWindow extends Component<IMachineInfoWindowProps, IMachineInfoWindowState> {
  constructor(props: IMachineInfoWindowProps) {
    super(props);
    this.state = {
      imageLink: '',
      imageLinkFallback: '',
    };
  }

  render() {
    const template = TemplateHelper.getTemplateByTypeId(this.props.TypeDefinition);

    const deviceClassVariable = {
      id: 'ddc4aaca-9595-49c0-b3bc-e39c52f20131',
      modelUri: 'http://opcfoundation.org/UA/Machinery/',
      nodeId: 'ns=1;i=6012',
      displayName: 'DeviceClass',
      variablePath: 'Data.DeviceClass',
      dataType: 'String',
      modellingRule: 'Optional',
      hasProperties: false,
    };

    const defaultImagePathClassifier = template?.imagesConfig.defaultImagePathClassifierVariable
      ? TemplateHelper.getVariableValue(this.props.Data, template.imagesConfig.defaultImagePathClassifierVariable)
      : TemplateHelper.getVariableValue(this.props, deviceClassVariable);

    const imageLinkFallback = URLs.getMachineImageBucketDefault(
      this.props.TypeDefinition,
      defaultImagePathClassifier,
      this.props.staticBucketReachable,
    );
    const imageLink = URLs.getMachineImageBucket(this.props.ImagePath, this.props.staticBucketReachable);
    const encoding = MachineHandling.getEncodingVersion(this.props);
    const linkTarget = FrontendURLs.getMachine({
      TypeDefinition: this.props.TypeDefinition,
      MachineId: this.props.MachineId,
      Encoding: encoding || 2,
    });
    const undefinedImagePath = this.props.ImagePath === undefined;
    console.log(this.props);
    const err = this.state.imageLink === imageLink && this.state.imageLinkFallback === imageLinkFallback;
    const name = MachineHandling.getMachineName(this.props);
    const inner = getInner(
      name,
      this.props.onMouseLeave,
      err ? imageLinkFallback : imageLink,
      this.props.children,
      linkTarget,
      err && !undefinedImagePath && <div className="text-mid">404</div>,
    );
    if (this.props.isCluster) {
      return inner;
    } else {
      return getInfoWindow(this.props, inner);
    }
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    staticBucketReachable: staticBucketReachable(state) || false,
  };
};

export default connect(mapStateToProps)(MachineInfoWindow);
